import { NgModule } from "@angular/core";
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSortModule } from '@angular/material/sort';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';

const modules = [
  MatCardModule,
  MatDatepickerModule,
  MatIconModule,
  MatTableModule,
  MatPaginatorModule,
  MatGridListModule,
  MatInputModule,
  MatSnackBarModule,
  MatSidenavModule,
  MatSlideToggleModule,
  MatButtonModule,
  MatListModule,
  MatTabsModule,
  MatMenuModule,
  MatExpansionModule,
  MatCheckboxModule,
  MatDialogModule,
  MatSortModule,
  MatSelectModule,
  MatRadioModule,
  MatAutocompleteModule,
  MatTooltipModule,
  MatBottomSheetModule
]

@NgModule({
  imports: modules,
  exports: modules,
  providers: [provideNativeDateAdapter()],
})
export class MaterialModule { }
